import { isAuthorized } from '../../src/utils/role' 

// isAuthorized(['admin', 'super_admin'])

// this.isAuthorized = isAuthorized(['admin', 'super_admin']);

export default [
    {
        _name: 'CSidebarNav',
        _children: [
            {
                _name: 'CSidebarNavItem',
                name: 'Dashboard',
                to: '/dashboard',
                icon: 'cil-speedometer',
                show: _adminOnly() && isAuthorized(['operator','concierge','other', 'business_admin','admin','super_admin','concierge_nigth'])
            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Бизнес'],
                show: isAuthorized(['operator','concierge','other', 'business_admin','admin','super_admin','concierge_nigth'])
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Заказы',
                to: '/orders',
                icon: 'cil-basket',
                items: [
                    {
                        icon: 'none',
                        name: 'Все',
                        to: '/orders',
                        show: _adminOnly()
                    },
                    {
                        icon: 'none',
                        name: 'Рестораны',
                        to: '/orders/orders-rd',
                        show: _accessRestaurants()
                    },
                    {
                        icon: 'none',
                        name: 'Цветы',
                        to: '/orders/orders-fd',
                        show: _accessFlorists()
                    },
                    {
                        icon: 'none',
                        name: 'Химчистки',
                        to: '/orders/orders-ld',
                        show: _accessLaundries()
                    },
                    {
                        icon: 'none',
                        name: 'Продукты',
                        to: '/orders/orders-gd',
                        show: _accessGrocers()
                    },
                    {
                        icon: 'none',
                        name: 'Аптеки',
                        to: '/orders/orders-pd',
                        show: _accessPharmacies()
                    },
                    {
                        icon: 'none',
                        name: 'Помощники',
                        to: '/orders/orders-ah',
                        show: _accessAssistant()
                    },
                ],
                show: isAuthorized(['operator','concierge','other', 'business_admin','admin','super_admin','concierge_nigth', 'operator_vip_city'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Сторонние доставки',
                to: '/other-delivery',
                icon: 'cil-bike',
                show: _adminOnly() && isAuthorized(['operator','other', 'business_admin','admin','super_admin','concierge_nigth', 'concierge'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Рестораны',
                to: '/restaurants',
                icon: 'cil-fastfood',
                show: _accessRestaurants() && isAuthorized(['operator','other', 'business_admin','admin','super_admin','concierge_nigth'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Магазины продуктов',
                to: '/grocers',
                icon: 'cil-balance-scale',
                show: _accessGrocers() && isAuthorized(['operator','other', 'business_admin','admin','super_admin','concierge_nigth'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Аптеки',
                to: '/pharmacies',
                icon: 'cil-beaker',
                show: _accessPharmacies() && isAuthorized(['operator','other', 'business_admin','admin','super_admin','concierge_nigth'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Помощники',
                to: '/assistants',
                icon: 'cil-running',
                show: _accessAssistant() && isAuthorized(['operator','other', 'business_admin','admin','super_admin','concierge_nigth'])
            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Другое'],
                show: _adminOnly() && isAuthorized(['operator','admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Чаты',
                to: '/chats',
                icon: 'cil-speech',
                show: _adminOnly() && isAuthorized(['operator','concierge','other', 'business_admin','admin','super_admin','concierge_nigth'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Спросы',
                icon: 'cil-graph',
                to: '/demands',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },

            {
                _name: 'CSidebarNavDropdown',
                name: 'Клиенты',
                icon: 'cil-people',
                to: '/customers',
                show: _adminOnly() && isAuthorized(['operator','admin','super_admin']),
                items: [
                    {
                        _name: 'CSidebarNavItem',
                        name: 'Клиенты',
                        icon: 'cil-people',
                        to: '/customers',
                        show: _adminOnly() && isAuthorized(['admin','super_admin'])
                    },
                    {
                        _name: 'CSidebarNavItem',
                        name: 'Бизнес-компании',
                        icon: 'cil-briefcase',
                        to: '/business-companies',
                        show: _adminOnly() && isAuthorized(['admin','super_admin'])
                    },
                    {
                        _name: 'CSidebarNavItem',
                        name: 'Сегменты',
                        icon: 'cil-chart-pie',
                        to: '/segments',
                        show: _adminOnly() && isAuthorized(['admin','super_admin'])
                    },
                    {
                        _name: 'CSidebarNavItem',
                        name: 'Тригерные рассылки',
                        icon: 'cil-bell',
                        to: '/trigger-campaigns',
                        show: _adminOnly() && isAuthorized(['admin','super_admin'])
                    },
                ]
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Зонирование',
                icon: 'cil-settings',
                to: '/delivery-zones',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Статусы отправки push',
                icon: 'cil-copy',
                to: '/push-status',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Партнеры',
                icon: 'cil-money',
                to: '/partners',
                show: _adminOnly() && isAuthorized(['admin','super_admin', 'operator_vip_city'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Контент партнёров',
                icon: 'cil-image',
                to: '/content-health',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Курьеры',
                icon: 'cil-bike',
                to: '/couriers',
                show: _adminOnly() && isAuthorized(['operator','admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Консьержи',
                icon: 'cil-badge',
                to: '/concierges',
                show: _adminOnly() && isAuthorized(['operator','admin','super_admin'])
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Промокоды',
                icon: 'cil-qr-code',
                to: '/promocodes',
                show: _adminOnly() && isAuthorized(['operator','admin','super_admin']),
                items: [
                    {
                        icon: 'none',
                        name: 'Все промокоды',
                        to: '/promocodes'
                    },
                    {
                        icon: 'none',
                        name: 'Массовая генерация',
                        to: '/promocodes/mass-generation'
                    },
                    {
                        icon: 'none',
                        name: 'Персональная генерация',
                        to: '/promocodes/personal'
                    },
                    {
                        icon: 'none',
                        name: 'История генераций',
                        to: '/promocodes/history'
                    },
                ]
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Акции',
                icon: 'cil-birthday-cake',
                to: '/promotions',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Банеры',
                icon: 'cil-brightness',
                to: '/banners',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Рекламные места',
                icon: 'cil-calculator',
                to: '/ads-places',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Промо страницы',
                icon: 'cil-window-restore',
                to: '/ads-campaigns',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Сторис',
                icon: 'cil-library',
                to: '/stories',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Онбординг',
                icon: 'cil-library',
                to: '/onboarding',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Опросы',
                icon: 'cil-list',
                to: '/surveys',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'АБ тестирование',
                icon: 'cil-chart-line',
                to: '/ab-tests',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'iiko Заказы',
                icon: 'cil-restaurant',
                to: '/iiko-orders',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Администрирование'],
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Администраторы',
                icon: 'cil-user',
                to: '/administrators',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Экспорт',
                icon: 'cil-copy',
                to: '/export',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Стол заказов',
                icon: 'cil-restaurant',
                to: '/shop-catalog',
                show: _adminOnly() && isAuthorized(['admin','super_admin'])
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Настройки',
                icon: 'cil-settings',
                show: _adminOnly() && isAuthorized(['admin','super_admin']),
                items: [
                    {
                        icon: 'none',
                        name: 'Главная страница',
                        to: '/settings/main-page',
                    },
                    {
                        icon: 'none',
                        name: 'Настройки меню для десктопа',
                        to: '/settings/desktop-menu',
                    },
                    {
                        icon: 'none',
                        name: 'Страница оплаты',
                        to: '/settings/payment-page',
                    },
                    {
                        icon: 'none',
                        name: 'Попап повтора заказа',
                        to: '/settings/repeat-order-sheet',
                    },
                    {
                        icon: 'none',
                        name: 'iiko Cards',
                        to: '/settings/iiko-cards',
                    },
                    {
                        icon: 'none',
                        name: 'QR по расписанию (iiko)',
                        to: '/settings/iiko-card-qr-schedule',
                    },
                    {
                        icon: 'none',
                        name: 'Настройки бизнеса',
                        to: '/settings/entities',
                    },
                    {
                        icon: 'none',
                        name: 'Исключение верификации',
                        to: '/settings/verification',
                    },
                    {
                        icon: 'none',
                        name: 'Сервисный сбор',
                        to: '/settings/service-fee',
                    },
                    {
                        icon: 'none',
                        name: 'Допродажи в статусе заказа',
                        to: '/settings/order-upsell',
                    },
                    {
                        icon: 'none',
                        name: 'Настройки доставки',
                        to: '/settings/delivery',
                    },
                    {
                        icon: 'none',
                        name: 'Обратная связь',
                        to: '/settings/feedback',
                    },
                    {
                        icon: 'none',
                        name: 'Версии',
                        to: '/settings/version',
                    },
                    {
                        icon: 'none',
                        name: 'Вопрос-ответ (FAQ)',
                        to: '/settings/faq',
                    },
                    {
                        icon: 'none',
                        name: 'Реферальная программа',
                        to: '/settings/referal-program',
                    },
                    {
                        icon: 'none',
                        name: 'Скидка за n-заказов',
                        to: '/settings/discount-on-orders',
                    },
                    {
                        icon: 'none',
                        name: 'Геймификация карт',
                        to: '/settings/card-scan-gamification',
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Тексты',
                icon: 'cil-text',
                show: _adminOnly() && isAuthorized(['admin','super_admin']),
                items: [
                    {
                        icon: 'none',
                        name: 'Пользовательское соглашение',
                        to: '/settings/agreement',
                    },
                    {
                        icon: 'none',
                        name: 'Согласие на обработку ПД',
                        to: '/settings/personal-information',
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Аналитика',
                icon: 'cil-graph',
                show: _adminOnly() && isAuthorized(['admin','super_admin']),
                items: [
                    {
                        icon: 'none',
                        name: 'Установки',
                        to: '/customer-logs'
                    },
                    {
                        icon: 'none',
                        name: 'Результаты форм',
                        to: '/forms-results'
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Справочники',
                icon: 'cil-calculator',
                show: _adminOnly() && isAuthorized(['admin','super_admin']),
                items: [
                    {
                        icon: 'none',
                        name: 'Категории',
                        to: '/categories'
                    },
                    {
                        icon: 'none',
                        name: 'Адреса Москва-Сити',
                        to: '/addresses'
                    },
                    {
                        icon: 'none',
                        name: 'Время подхода к башням',
                        to: '/tower-time'
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Клиенты',
                icon: 'cil-contact',
                show: _adminOnly() && isAuthorized(['admin','super_admin']),
                items: [
                    {
                        icon: 'none',
                        name: 'Коды верификации',
                        to: '/verification-codes'
                    },
                ]
            },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Сервисы',
                icon: 'cil-3d',
                show: _adminOnly() && isAuthorized(['admin','super_admin']),
                items: [
                    {
                        icon: 'none',
                        name: 'Курьерский сервис',
                        to: '/courier-service'
                    },
                    {
                        icon: 'none',
                        name: 'СМС Сервис',
                        to: '/sms-service'
                    },
                    {
                        icon: 'none',
                        name: 'Хуки iiko',
                        to: '/iiko-hooks'
                    },
                    {
                        icon: 'none',
                        name: 'Хуки Yuma',
                        to: '/yuma-hooks'
                    },
                    // {
                    //     icon: 'none',
                    //     name: 'Импорт изображений',
                    //     to: '/pic-recover-service'
                    // },
                    {
                        icon: 'none',
                        name: 'Telegram',
                        to: '/telegram'
                    },
                    {
                        icon: 'none',
                        name: 'MAX',
                        to: '/max'
                    },
                    {
                        icon: 'none',
                        name: 'Логи',
                        to: '/change-logs'
                    },
                ]
            },

            {
                _name: 'CSidebarNavTitle',
                _children: ['VipCity'],
                show: isAuthorized(['super_admin', 'admin']),
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Партнеры',
                to: '/vip-partners',
                icon: 'cil-money',
                show: isAuthorized(['super_admin', 'admin']),
            },
            {
                _name: 'CSidebarNavItem',
                name: 'Заказы',
                to: '/vip-partners/orders',
                icon: 'cil-basket',
                show: isAuthorized(['super_admin', 'admin']),
            },
        ]
    }
]

function _adminOnly() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    return settings ? !settings.is_business_admin : true;
}

function _accessRestaurants() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (settings) {
        if (settings.is_business_admin) {
            if (settings.restaurants && settings.restaurants.length) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return true;
    }
}

function _accessFlorists() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (settings) {
        if (settings.is_business_admin) {
            if (settings.florists && settings.florists.length) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return true;
    }
}

function _accessLaundries() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (settings) {
        if (settings.is_business_admin) {
            if (settings.laundries && settings.laundries.length) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return true;
    }
}

function _accessGrocers() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (settings) {
        if (settings.is_business_admin) {
            if (settings.grocers && settings.grocers.length) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return true;
    }
}

function _accessPharmacies() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (settings) {
        if (settings.is_business_admin) {
            if (settings.pharmacies && settings.pharmacies.length) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return true;
    }
}

function _accessAssistant() {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (settings) {
        if (settings.is_business_admin) {
            if (settings.assistant && settings.assistant.length) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return true;
    }
}
